import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@utils/constant";

const PopupDialogStyle = makeStyles((theme) => ({
  customModal: {
    "& .MuiPaper-root.MuiDialog-paper": {
      boxShadow: "0 3px 8px 0 rgba(0, 0, 0, 0.24)",
      padding: "40px",
      "& .dialogTitle": {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: theme.spacing(0, 0, 2, 0),
        "& .titleText": {
          fontWeight: "700",
          fontSize: "24px",
          lineHeight: "1.321",
          color: colors.black,
        },
        "& .closeButton": {
          marginLeft: theme.spacing(1),
          padding: theme.spacing(0.5),
        }
      },
      "& .dialogContent": {
        padding: theme.spacing(2, 0, 2, 0),
      },
      "& .MuiDialogContent-root": {
        "& .MuiTypography-root": {
          fontWeight: "400",
          fontSize: "18px",
          lineHeight: "1.44",
          color: colors.black,
        },
      },
      "& .MuiDialogActions-root": {
        padding: theme.spacing(2, 0, 0, 0),
        justifyContent: "space-between",
        "@media(max-width:374px)": {
          flexWrap: "wrap",
        },
        "& button": {
          height: "50px",
          lineHeight: "50px",
          fontSize: "16px",
          fontWeight: "600",
          textTransform: "uppercase",
          minWidth: "165px",
          "@media(max-width:767px)": {
            minWidth: "140px",
          },
          "@media(max-width:374px)": {
            maxWidth: "100%",
            flex: "0 0 100%",
          },
        },
        "& button + button": {
          marginLeft: "20px",
          "@media(max-width:767px)": {
            marginLeft: "15px",
          },
          "@media(max-width:374px)": {
            margin: "15px 0 0",
          },
        },
        "& button:only-child": {
          marginLeft: "auto",
          marginRight: "auto",
          "@media(max-width:374px)": {
            flex: "0 0 auto",
            maxWidth: "none",
          },
        },
      },
    },
  },
}));

export { PopupDialogStyle };
